export const getMetaTagValue = (metaTag: 'csrf-token' | 'apple-auth-nonce') => {
  const meta = document.querySelector(`meta[name="${metaTag}"]`);
  if (meta) {
    return meta.getAttribute('content');
  }
};
